import React from 'react';
import { useParams } from 'react-router-dom';
import Constants from '../../utils/Constants';
import { ErrorPage } from '../../components/ErrorPage/ErrorPage';
import { ErrorType } from '../../services/ErrorBoundaryService';
import { NewPdnApplication } from './NewPdnApplication';
import { NewPdnManifold } from './NewPdnManifold';
import { NewPdnActuator } from './NewPdnActuator';
import { NewPdnActuatorAoM } from './NewPdnActuatorAoM';

export const Shortcuts = () => {
  const errorPage = <ErrorPage errorType={ErrorType.ShortcutNotFound} />;
  const componentsMap = new Map();
  componentsMap.set(Constants.shortcuts.pdnManifold, <NewPdnManifold />);
  componentsMap.set(Constants.shortcuts.pdnApplication, <NewPdnApplication />);
  componentsMap.set(Constants.shortcuts.pdnActuator, <NewPdnActuator />);
  componentsMap.set(Constants.shortcuts.pdnActuatorAoM, <NewPdnActuatorAoM />);

  const { shortcutKey } = useParams();
  if (!componentsMap.has(shortcutKey)) {
    return errorPage;
  }
  return componentsMap.get(shortcutKey);
};
